const fr = {
  tools_actions: {
    hotel_info: "Je recherche des informations sur l'hôtel...",
    accommodation_info: "Je recherche des informations sur l'hôtel...",
    accomodation_info: "Je recherche des informations sur l'hôtel...",
    get_destination_info: "Je cherche des activités à proximité...",
    get_guest_information: "Je vérifie votre réservation...",
    book_hotel_service_or_get_availability: "Je vérifie la disponibilité du service...",
    list_accomodations: "Je charge les établissements...",
    set_accomodation: "Je charge l'établissement...",
    list_accommodations: "Je charge les établissements...",
    set_accommodation: "Je charge l'établissement...",
    destination_info: "Je cherche des activités à proximité...",
    show_map: "Je prépare la carte...",
    consult_rules: "Je consulte le règlement de l'établissement...",
    notify_reception: "J'informe la réception...",
    save_self_declared_stay: "J'enregistre votre séjour...",
    generate_quote_for_single_room_longstay_rooms: "Je prépare un devis...",
    generate_quote_for_multiple_rooms_longstay: "Je prépare un devis...",
    hotel_info_iodah:
      "Parfait, je réunis les informations et je reviens vers vous tout de suite...",
    generate_quote_for_rooms: "Je prépare un devis...",
    check_availability: "Je vérifie les disponibilités...",
    print_calendar: "Je consulte le calendrier...",
    nearby_restaurants: "Je cherche des restaurants à proximité...",
    nearby_attractions: "Je cherche des attractions à proximité...",
    human_handoff: "Mise en relation avec un conseiller...",
    tool_search_offers_by_request: "Je recherche les meilleures offres pour vous...",
    tool_search_hotels_by_request: "Je recherche les meilleurs hôtels pour vous...",
  },
  tool_status_sequences: {
    generate_quote_for_rooms: [
      "Je vérifie les disponibilités pour vos dates…",
      "Je compare les chambres et les tarifs…",
      "Je prépare votre devis…",
    ],
    generate_quote_for_single_room_longstay_rooms: [
      "Je vérifie les disponibilités pour vos dates…",
      "Je compare les chambres et les tarifs…",
      "Je prépare votre devis…",
    ],
    generate_quote_for_multiple_rooms_longstay: [
      "Je vérifie les disponibilités pour vos dates…",
      "Je compare les chambres et les tarifs…",
      "Je prépare votre devis…",
    ],
    check_availability: [
      "Je consulte le calendrier…",
      "Je vérifie les disponibilités…",
      "Encore un instant…",
    ],
    hotel_info: [
      "Je consulte les informations de l'hôtel…",
      "Je rassemble les détails…",
      "Je prépare la réponse…",
    ],
    accommodation_info: [
      "Je consulte les informations de l'hôtel…",
      "Je rassemble les détails…",
      "Je prépare la réponse…",
    ],
    accomodation_info: [
      "Je consulte les informations de l'hôtel…",
      "Je rassemble les détails…",
      "Je prépare la réponse…",
    ],
    get_destination_info: [
      "J'explore les environs…",
      "Je sélectionne les meilleures suggestions…",
      "Presque prêt…",
    ],
    nearby_restaurants: [
      "Je cherche les restaurants du secteur…",
      "Je sélectionne les plus adaptés…",
      "Presque prêt…",
    ],
    nearby_attractions: [
      "Je cherche des activités à proximité…",
      "Je sélectionne le meilleur…",
      "Presque prêt…",
    ],
    get_guest_information: [
      "Je retrouve votre réservation…",
      "Je vérifie les détails de votre séjour…",
      "Encore un instant…",
    ],
    book_hotel_service_or_get_availability: [
      "Je vérifie la disponibilité du service…",
      "Je consulte les horaires…",
      "Encore un instant…",
    ],
    print_calendar: ["J'ouvre le calendrier…", "Je vérifie les dates…"],
    list_accomodations: ["Je charge les établissements…", "Je prépare la liste…"],
    set_accomodation: ["J'ouvre l'établissement…", "Je récupère les informations…"],
    list_accommodations: ["Je charge les établissements…", "Je prépare la liste…"],
    set_accommodation: ["J'ouvre l'établissement…", "Je récupère les informations…"],
    destination_info: [
      "J'explore les environs…",
      "Je sélectionne les meilleures suggestions…",
      "Presque prêt…",
    ],
    show_map: ["Je localise les lieux sur la carte…", "Je prépare l'itinéraire…"],
    consult_rules: ["Je consulte le règlement de l'établissement…", "Je vérifie les conditions…"],
    notify_reception: ["J'informe la réception…", "Je transmets la demande…"],
    save_self_declared_stay: ["J'enregistre votre séjour…", "Je relie la réservation…"],
    human_handoff: ["J'informe la réception…", "Je transmets la conversation…"],
    tool_search_offers_by_request: [
      "Je recherche les meilleures offres pour vous…",
      "Je compare les options…",
      "Presque prêt…",
    ],
    tool_search_hotels_by_request: [
      "Je recherche les hôtels les plus adaptés…",
      "Je compare les options…",
      "Presque prêt…",
    ],
  },
  status_thinking: ["Un instant…", "J'y réfléchis…", "Encore un instant…"],
  status_generic: ["Nous y sommes presque…", "Encore un instant…"],
  tooltip_sentences: [
    "Besoin d'un devis rapide ? 😊",
    "Besoin d'informations sur l'hôtel ? 😊",
  ],
  // Variant B of the open-rate experiment: two clickable teaser pills ·
  // a fixed high-intent hook on top, a rotating multi-intent pill below.
  // A click opens the chat and sends the pill as the guest message.
  // Hotels can override these from the backoffice (per locale); these are
  // the defaults when no configuration is present.
  welcome_message_default:
    "Bonjour ! 👋 Je suis l'assistant virtuel de l'hôtel. Je peux vérifier les disponibilités et les tarifs et répondre à toutes vos questions sur votre séjour. Comment puis-je vous aider ?",
  teaser_pill_fixed: "Devis en 30 secondes ⚡",
  teaser_pills_rotating: [
    "Des chambres libres à ces dates ? 📅",
    "Quelles chambres avez-vous ? 🛏️",
    "Comment est le petit-déjeuner ? 🥐",
  ],
  quote_pills: {
    alone: "Juste moi",
    alone_message: "Juste moi, une personne",
    party: "Nous sommes {n}",
    party_message: "Nous sommes {n} personnes",
  },
  replies_in_realtime: "Réponses en temps réel",
  ai_disclosure: "Je suis l'assistant IA de l'établissement. Vous pouvez demander le personnel quand vous le souhaitez.",
  powered_by: "Propulsé par",
  type_a_message: "Écrivez un message...",
  speak_with_operator: "Parler à un conseiller",
  // "Call us" card in the welcome message (VoiceCallCard).
  voice_call: {
    title: "Appelez-nous",
    subtitle: "Notre assistant vocal répond tout de suite",
    badge: "Nouveau",
    call: "Appeler",
    copy: "Copier le numéro",
    copied: "Numéro copié",
  },
  continue_on_whatsapp: "Continuer sur WhatsApp",
  whatsapp_handoff_prefill:
    "Bonjour ! J'échangeais avec l'assistant sur votre site et je souhaite continuer ici.",
  request_quote: "Demander un devis",
  map_directions: "Ouvrir dans Maps",
  handoff_form: {
    title: "Contactez-nous",
    desc: "Laissez-nous vos coordonnées et notre équipe vous recontactera dans les plus brefs délais.",
    firstname: "Prénom",
    lastname: "Nom",
    email: "E-mail",
    phone: "Téléphone",
    phone_hint: "Nous l'utiliserons pour vous joindre, y compris sur WhatsApp.",
    phone_search: "Rechercher un pays",
    submit: "Envoyer la demande",
    success:
      "Merci ! Nous avons bien reçu vos coordonnées et nous vous recontacterons dans les plus brefs délais. 😊",
    handoff_email_success:
      "Nous vous répondrons par e-mail à {email}. Vous pouvez fermer cette page.",
    submit_error: "Une erreur s'est produite. Veuillez réessayer sous peu.",
    firstname_error: "Veuillez indiquer votre prénom.",
    lastname_error: "Veuillez indiquer votre nom.",
    email_error: "Veuillez indiquer une adresse e-mail valide.",
    phone_error: "Veuillez indiquer un numéro de téléphone valide.",
  },
  delete_chat_aria_label: "Supprimer la conversation",
  close_aria_label: "Fermer la conversation",
  send_aria_label: "Envoyer le message",
  open_content: "Ouvrir les contenus",
  book_now: "Réserver maintenant",
  // Inline link chips in a message (CustomLinkRenderer): shown next to the
  // address/number the assistant wrote, and used as the accessible label.
  send_email: "Envoyer un e-mail",
  call_now: "Appeler",
  whatsapp_chat: "Écrivez-nous sur WhatsApp",
  open_link: "Ouvrir le lien",
  discover_hotel: "Découvrir l'hôtel",
  discover_offer: "Découvrir l'offre",
  quick_quote: "Demander un devis rapide",
  view_hotel_photos: "Voir les photos de l'hôtel",
  view_photos: "Voir les photos",
  hotel_gallery: "Hôtel",
  restaurant_gallery: "Restaurant",
  animation_gallery: "Animation",
  rooms_gallery: "Chambres",
  look_hotel_galleries: "Voir les autres galeries de l'hôtel :",
  back_to_chat: "Retour à la conversation",
  carousel_open: "Ouvrir",
  carousel_close: "Fermer",
  available: "Disponible",
  expand_view: "Vue immersive",
  read_more: "En savoir plus",
  explore: "Explorer",
  photo: "Photo",
  from_price: "dès",
  rates: "Tarifs",
  quote_group: {
    title: "Votre devis",
    total: "Total",
    room: "Chambre {n}",
    other_options: "Autres options",
    rooms: "{n} chambres",
    adult: "adulte",
    adults: "adultes",
    child: "enfant",
    children: "enfants",
  },
  anchor_rooms: "Nos propositions",
  anchor_discover: "À découvrir",
  anchor_places: "Situation et environs",
  anchor_videos: "Vidéos",
  videos: "vidéos",
  watch_video: "Voir la vidéo",
  feedback_useful: "Réponse utile",
  feedback_not_useful: "Peu utile",
  proposal: "proposition",
  proposals: "propositions",
  contents: "contenus",
  places: "lieux",
  explore_title: "Votre séjour",
  explore_rooms: "Chambres et tarifs",
  explore_discover: "À découvrir",
  explore_videos: "Vidéos",
  explore_places: "Lieux",
  directions: "Itinéraire",
  minimize_view: "Réduire",

  // 1x6 P2-d-M · interactive concierge map (poi_map / itinerary templates).
  anchor_itinerary: "Votre itinéraire",
  itinerary: "Itinéraire",
  stops: "étapes",
  stop: "étape",
  walk_min: "min à pied",
  itinerary_start: "Point de départ",
  your_hotel: "Votre hôtel",
  explore_itineraries: "Itinéraires",
  map_loading: "Chargement de la carte…",
  cat_restaurant: "Manger & boire",
  cat_attraction: "Sites à voir",
  cat_beach: "Plages",
  cat_essential: "Services utiles",
  cat_event: "Événements",
  cat_place: "Lieu",
  reviews: "avis",

  booking: {
    choose_rate: "Choisissez votre tarif",
    your_details: "Vos coordonnées",
    review: "Récapitulatif",
    notes: "Notes ou demandes",
    notes_placeholder: "Allergies, heure d'arrivée, lit bébé…",
    privacy: "J'ai lu et j'accepte la politique de confidentialité.",
    marketing: "Je souhaite recevoir les offres et actualités de l'hôtel.",
    privacy_required:
      "Le consentement à la confidentialité est nécessaire pour continuer.",
    continue: "Continuer",
    back: "Retour",
    confirm: "Confirmer la réservation",
    submitting: "Un instant…",
    cancel: "Annuler",
    close: "Fermer",
    retry: "Réessayer",
    total: "Total",
    cheapest: "Le moins cher",
    per_night: "par nuit",
    no_payment_now: "Aucun paiement maintenant",
    nights: "nuits",
    guests: "personnes",
    reference: "Référence",
    success_title: "Réservation confirmée",
    success_body: "Vous recevrez votre confirmation par e-mail sous peu.",
    error_title: "Cela n'a pas abouti",
    error_body:
      "Nous n'avons pas pu finaliser la réservation. Merci de réessayer dans un instant.",
    mock_notice: "Mode test : aucune réservation réelle n'a été créée.",
  },
};

export default fr;
